export default "__VITE_ASSET__CZ8fg9Qk__"